/* eslint-disable @next/next/no-img-element */
import dayjs from 'dayjs'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import Layout from 'components/Layout'
import Meta from 'components/Meta'
import ManageDashboard from 'components/manage/ManageDashboard'
import type { ReactElement } from 'react'

dayjs.extend(localizedFormat)

const ManagePage = () => {
  return (
    <>
      <Meta title="Manage Dashboard" />
      <ManageDashboard />
    </>
  )
}

ManagePage.getLayout = (page: ReactElement) => <Layout>{page}</Layout>

export default ManagePage
